import React from 'react';
import { Box, Grid, Container } from '@material-ui/core';
// import Footer from '../components/reusableComponents/Footer';
// import Headers from '../components/reusableComponents/Headers';
import Nepa1 from '../../assets/images/Nepal1.jpeg';
import Nepal2 from '../../assets/images/Nepal2.jpeg';
import Nepal3 from '../../assets/images/Nepal3.jpeg';
import Nepal4 from '../../assets/images/Nepal4.jpeg';
import Nepal5 from '../../assets/images/Nepal5.jpeg';
import HeaderSection from '../../components/reusableComponents/HeaderSection';
import Footer from './Footer';
import EnquiryForm from '../../form/EnquiryForm';
// import EnquiryForm from '../form/EnquiryForm';
const data = [
	{
		title: 'Introduction to Kolkata',
		image: Nepal3,
		desc: 'Description',
	},
	{
		title: 'Day 1',
		image: Nepal2,
		desc: 'Description',
	},
	{
		title: 'Day 2: ',
		image: Nepal4,
		desc: 'Description',
	},
	{
		title: 'Day 3',
		image: Nepal5,
		desc: 'Description',
	},
];
const BlogDetailSection = () => {
	return (
		<>
			<HeaderSection />
			<Container style={{ marginTop: 100, marginBottom: 40 }}>
				<Grid container spacing={4}>
					<Grid item xs={8}>
						<Box>
							<img
								src={Nepa1}
								style={{ width: '100%', height: '100%', borderRadius: 5 }}
							/>
							<h1 style={{ marginTop: 26, fontSize: 24 }}>
								Kolkata Travel Blog
							</h1>
							<span style={{ color: 'grey' }}>By Musafir Bazar</span>
							{data.map((d) => {
								return (
									<Box>
										<h3 style={{ marginTop: 10, fontWeight: 'bold' }}>
											{d.title}
										</h3>
										<img src={d.image} />
										<p style={{ color: 'grey', marginTop: 10 }}>{d.desc}</p>
									</Box>
								);
							})}
						</Box>
					</Grid>
					<Grid item xs={4}>
						<Box>
							<h3>Quick Enquiry</h3>
							<EnquiryForm />
							{/* <EnquiryForm /> */}
						</Box>
					</Grid>
				</Grid>
			</Container>
			<Footer />
		</>
	);
};

export default BlogDetailSection;
